import React from 'react';
import { FlowRoutes } from '@app/modules/flow/flow.routes';
import { Navigate } from 'react-router-dom';
export const FlowRedirect = () => {
    return React.createElement(Navigate, { to: FlowRoutes.Steps });
};
